// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file entities/app/messages/message_type.proto (package protos.entities.app.messages, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file entities/app/messages/message_type.proto.
 */
export const file_entities_app_messages_message_type: GenFile = /*@__PURE__*/
  fileDesc("CihlbnRpdGllcy9hcHAvbWVzc2FnZXMvbWVzc2FnZV90eXBlLnByb3RvEhxwcm90b3MuZW50aXRpZXMuYXBwLm1lc3NhZ2VzKl0KC01lc3NhZ2VUeXBlEhgKFE1FU1NBR0VfVFlQRV9VTktOT1dOEAASFQoRTUVTU0FHRV9UWVBFX1RFWFQQARIdChlNRVNTQUdFX1RZUEVfU1lTVEVNX0VWRU5UEAJiBnByb3RvMw");

/**
 * @generated from enum protos.entities.app.messages.MessageType
 */
export enum MessageType {
  /**
   * @generated from enum value: MESSAGE_TYPE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: MESSAGE_TYPE_TEXT = 1;
   */
  TEXT = 1,

  /**
   * @generated from enum value: MESSAGE_TYPE_SYSTEM_EVENT = 2;
   */
  SYSTEM_EVENT = 2,
}

/**
 * Describes the enum protos.entities.app.messages.MessageType.
 */
export const MessageTypeSchema: GenEnum<MessageType> = /*@__PURE__*/
  enumDesc(file_entities_app_messages_message_type, 0);

